<template>
  <div class="searchIcon">
    <div class="searchIcon-content">
      <p class="searchIcon-head">検索結果</p>
      <p class="searchIcon-result">
        <template>{{ zeroPaddingNumber }}</template>
        <span class="searchIcon-unit">件</span>
      </p>
    </div>
  </div>
</template>
<script>
import velocity from "velocity-animate";

export default {
  name: "SearchIcon",
  props: {
    number: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      value: 0,
    };
  },
  computed: {
    zeroPaddingNumber() {
      return String(this.value).padStart(2, "0");
    },
  },
  created() {
    this.value = this.number;
  },
  watch: {
    number(currentNum, prevNum) {
      velocity(this.$el, "stop");
      velocity(
        this.$el,
        {
          tween: [currentNum, prevNum],
        },
        {
          begin: () => {
            this.value = prevNum;
          },
          progress: (elements, complete, remaining, start, tweenValue) => {
            this.value = Math.round(tweenValue);
          },
          duration: 400,
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.searchIcon {
  width: 92px;
  height: 100px;
  background: url("../../../assets/images/_parts/other/search_pc.svg") no-repeat
    center/contain;
  position: relative;

  .searchIcon-content {
    $size: 83px;
    width: $size;
    height: $size;
    text-align: center;
    position: absolute;
    top: 2px;
    left: 2px;
    font-size: 13px;
    background-color: #fff;
    border-radius: 50%;
    line-height: 1;
    color: $main-red;
  }

  .searchIcon-head {
    margin-top: 23px;
  }

  .searchIcon-result {
    font-size: 28px;
    color: $main-red;
    font-family: Oswald;
    position: relative;
    top: 4px;
    letter-spacing: 1.2px;
    color: $main-red;
  }

  .searchIcon-unit {
    font-size: 13px;
    position: relative;
    top: -1px;
    color: $main-red;
  }

  @include media() {
    width: vw(64);
    height: vw(70);
    background: url("../../../assets/images/_parts/other/search_sp.svg")
      no-repeat center/contain;

    .searchIcon-content {
      width: vw(57);
      height: vw(57);
      top: vw(2);
      left: vw(2);
      font-size: vw(10);
    }

    .searchIcon-head {
      margin-top: vw(15);
    }

    .searchIcon-result {
      font-size: vw(18);
      top: vw(4);
      letter-spacing: vw(1.2);
    }

    .searchIcon-unit {
      font-size: vw(10);
      top: vw(-1);
    }
  }
}
</style>
